// import {applyMixins} from '../chart_helpers/HelperMixin'
import { mergeConfig } from '../utils/configUtils'
import { formatNumber } from '../utils/formatUtils'
import { timeFormat as d3_timeFormat } from 'd3-time-format'
import NumberSuffix from 'number-suffix'

export default class BaseChart {
  _data = null
  _ghostData = null
  get data() {
    return this._data
  }
  set data(value) {
    this._data = value
    // Guarro este "_helpersUpdated", pero HAY que updatear la primera vez y no las siguientes... no?
    // pues parece que no, el ParalellCoords neceista update del axis helper por si aparecen "ejes nuevos"!!!!
    // if(!this._helpersUpdated)
    this.updateHelpers()
    this._draw()
  }
  get ghostData() {
    return this._ghostData
  }
  set ghostData(value) {
    this._ghostData = value
    this.updateHelpers()
    this._draw()
  }
  get config() {
    return this._config
  }
  set config(value) {
    this._config = value // extractValues(mergeConfig(this._getConfig(),value))
    this.updateHelpers()
    this._draw()
  }

  constructor($root) {
    this.$root = $root
    window.__sdv_counter__ = (window.__sdv_counter__ || 0) + 1
    this._chartId = window.__sdv_counter__
    // this.config = mergeConfigValues(this.constructor.defaultConfig,config)
    this.helperListeners = {}
    this.initHelpers()

    this.numberSuffix = new NumberSuffix()
    this.numberSuffix.addStyle('myStyle', ['K', 'M', 'B', 'T'])
    this.numberSuffix.setDefaultStyle('myStyle')
  }
  getValueFormat(onAxis) {
    let formatString
    let index = 0
    if (this.config.AxisHelper) {
      if (onAxis && onAxis.indexOf('_') >= 0) index = +onAxis.split('_')[1]
      if (onAxis !== void 0 && Array.isArray(this.config.AxisHelper[onAxis[0]].valueFormat))
        formatString =
          this.config.AxisHelper[onAxis[0]].valueFormat[index] ||
          this.config.AxisHelper[onAxis[0]].valueFormat[0]
      else if (onAxis) formatString = this.config.AxisHelper[onAxis[0]].valueFormat
      else
        formatString =
          this.config.valueFormat ||
          this.config.AxisHelper.y.valueFormat ||
          this.config.AxisHelper.x.valueFormat
    }
    if (!formatString) formatString = this.config.valueFormat || ''
    return formatString
  }
  getUnit(onAxis) {
    let unit
    let index
    if (onAxis) {
      if (onAxis.indexOf('_') >= 0) index = onAxis.split('_')[1]
      if (this.config.AxisHelper && this.config.AxisHelper[onAxis[0]].unit) {
        if (index !== undefined && Array.isArray(this.config.AxisHelper[onAxis[0]].unit))
          unit = this.config.AxisHelper[onAxis[0]].unit[index]
        else unit = this.config.AxisHelper[onAxis[0]].unit
      } else unit = this.config.unit
    } else {
      if (this.config.unit) unit = this.config.unit
      else if (this.config.AxisHelper)
        unit =
          (this.config.AxisHelper.y && this.config.AxisHelper.y.unit) ||
          (this.config.AxisHelper.x && this.config.AxisHelper.x.unit)
    }
    return unit
  }
  matchFormatString(formatString) {
    let regex = /(?:\[([DNSA])\])?(.+)/
    let match = formatString.match(regex)
    return match
  }
  getValueType(onAxis) {
    let match = this.matchFormatString(this.getValueFormat(onAxis))
    return match && match[1]
  }
  formatValue(value, onAxis) {
    let match = this.matchFormatString(this.getValueFormat(onAxis))
    let type = match && match[1]
    let format = match && match[2]

    if (type === 'D') return d3_timeFormat(format)(value)
    else if (type === 'A') return this.numberSuffix.format(value, JSON.parse(format))
    else if (!isNaN(Number(value))) return formatNumber(value, format).toUpperCase()
    else return value || '-'
  }

  valueWithUnit(value, onAxis) {
    let formattedValue = this.formatValue(value, onAxis)
    let unit = this.getUnit(onAxis)
    let unitsThatGoBefore = ['$', '¤', '£']
    if (unitsThatGoBefore.indexOf(unit) >= 0) return unit + formattedValue
    else if (unit) return formattedValue + ' ' + unit
    else return formattedValue
    // return unit?formattedValue+' '+unit:formattedValue
  }

  initHelpers() {
    // console.log('init helpers')
    this._beforeDraws = []
    this._afterDraws = []
    this._helperIds = []
    this.__proto__.constructor.helpers.forEach(helperDef => {
      let helperClass
      if (typeof helperDef === 'function') {
        helperClass = helperDef
      } else {
        helperClass = helperDef.class
      }
      const { init, beforeDraw, afterDraw, ...rest } = helperClass
      Object.assign(this.__proto__.constructor.prototype, rest)
      init.call(this)
      this._beforeDraws.push(beforeDraw)
      this._afterDraws.push(afterDraw)
      this._helperIds.push(helperClass.configName)
    })
  }

  updateHelpers() {
    if (!this.data) return
    this._helpersUpdated = true
    // console.log('update helpers')
    this.__proto__.constructor.helpers.forEach(helperDef => {
      let helperClass
      if (typeof helperDef === 'function') {
        helperClass = helperDef
      } else {
        helperClass = helperDef.class
      }
      const { update } = helperClass
      update.call(this)
    })
  }

  _draw() {
    if (!this.data) return
    // console.log('----> drawing chart')
    this.beforeHelpers()
    this._beforeDraws.forEach(bd => {
      bd.call(this)
    })
    this.beforeDraw()

    this.draw()

    this.afterDraw()
    this._afterDraws.forEach(ad => {
      ad.call(this)
    })
    this.afterHelpers()
  }

  beforeHelpers() {}
  beforeDraw() {}
  draw() {
    console.warn(`Viz ${this.constructor.name} must implement draw()`)
  }
  afterDraw() {}
  afterHelpers() {}

  _getConfig() {
    // console.log("this.helpers",this.constructor.helpers)
    let config = mergeConfig(
      this.__proto__.constructor.defaultConfig,
      this.constructor.defaultConfig
    )
    return this.constructor.helpers.reduce((res, helperDef) => {
      // let clasDef = h.class || h
      // return mergeConfig(config,{[clasDef.name]:clasDef.defaultConfig})

      // A VER sI SE PUEDE UNIFICAR "BIEN" Con el otro "mergeConfigValues"
      let helperConfig
      let helperClass
      if (typeof helperDef === 'function') {
        helperConfig = {}
        helperClass = helperDef
      } else {
        helperConfig = helperDef.config
        helperClass = helperDef.class
      }
      const { defaultConfig } = helperClass
      let helperName = helperClass.configName
      return mergeConfig({ [helperName]: mergeConfig(defaultConfig, helperConfig) }, res)
    }, config)
  }
}
